import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/editorial.css';

export function Reveal({ children, className = '', delay = 0 }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!window.IntersectionObserver || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('editorial-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={className} style={{ '--reveal-delay': `${delay}s` }}>{children}</div>;
}
export function PageHero({ page, eyebrow, title, accent, description, children }) {
  return <header className="editorial-hero"><div className="editorial-container">
    <nav className="editorial-breadcrumb" aria-label="Breadcrumb"><Link to="/">Home</Link><span aria-hidden="true">/</span><span aria-current="page">{page}</span></nav>
    <Reveal><span className="editorial-eyebrow">{eyebrow}</span><h1>{title} <span>{accent}</span></h1><p>{description}</p>{children}</Reveal>
    <div className="editorial-blueprint" aria-hidden="true"><i /><i /><i /></div>
  </div></header>;
}
export function PageCTA({ title = 'Your next project starts with a conversation.', description = 'Tell us what you’re building. Let’s find the right estimating support for your team.' }) {
  return <div className="editorial-container"><Reveal className="editorial-cta"><div><span className="editorial-eyebrow">LET’S BUILD TOGETHER</span><h2>{title}</h2><p>{description}</p></div><Link className="editorial-button" to="/contact-us">Talk to our team <span aria-hidden="true">↗</span></Link></Reveal></div>;
}
